/**
 * @generated SignedSource<<a96d0132f020239938f30d7c861dec3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteBrainSearchButtonMutation$variables = {
  id: string;
};
export type DeleteBrainSearchButtonMutation$data = {
  readonly response: {
    readonly deletedBrainSearchId: string | null;
  };
};
export type DeleteBrainSearchButtonMutation = {
  response: DeleteBrainSearchButtonMutation$data;
  variables: DeleteBrainSearchButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedBrainSearchId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBrainSearchButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteBrainSearchResponse",
        "kind": "LinkedField",
        "name": "deleteBrainSearch",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBrainSearchButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteBrainSearchResponse",
        "kind": "LinkedField",
        "name": "deleteBrainSearch",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedBrainSearchId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5312844cb4491549f16740db6fd9bfa",
    "id": null,
    "metadata": {},
    "name": "DeleteBrainSearchButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBrainSearchButtonMutation(\n  $id: ID!\n) {\n  response: deleteBrainSearch(id: $id) {\n    deletedBrainSearchId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9ad8bb71bf9db01da4f0857745f1c5c";

export default node;
